// extracted by mini-css-extract-plugin
export var autoSpacing = "ButtonGroup-module--auto-spacing--c9bc7";
export var group = "ButtonGroup-module--group--a8683";
export var lgSpacing = "ButtonGroup-module--lg-spacing--0b679";
export var mdSpacing = "ButtonGroup-module--md-spacing--25421";
export var smSpacing = "ButtonGroup-module--sm-spacing--12d24";